/**
 * Switch between browser and server environment and return the appropriate
 * TrackJS agent.
 */
module.exports =
  typeof window !== 'undefined' ? require('trackjs') : require('trackjs-node');
